import { useEffect } from "react";

const useFadeOnScroll = (ref, options = {}) => {
  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target); // animate only once
        }
      },
      {
        root: null,
        threshold: 0,
        rootMargin: "-20% 0px -20% 0px",
      }
    );

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, options]);
};

export default useFadeOnScroll;
